const state = {
  isCollapse: false,      // 主页面左侧菜单的 "展开、关闭" 状态
  crumbInfo: [],          // 头部的面包屑

  activeTab: '',          // 头部的视图页签激活
  tabList: []             // 头部的视图页签列表
};


const mutations = {
  setToggle: function (state, value) {
    state.isCollapse = value;
  },
  setHeadCrumb: function (state, value) {
    state.crumbInfo = value;
  },
  setActiveTab: function (state, value) {
    state.activeTab = value;
  },
  setTabList: function (state, data) {
    state.activeTab = (data.router).toString();

    let list = state.tabList;
    for (let i = 0; i < list.length; i++) {
      if (list[i].router == data.router) {
        return;
      }
    }
    state.tabList.push(data);
  },
  delTab: function (state, data) {
    switch (data.type) {
      case 1:
        let index = data.index;
        if (state.tabList[index].router == state.activeTab) {
          let tab = state.tabList[index + 1] || state.tabList[index - 1];
          state.activeTab = tab.router;
        }
        state.tabList.splice(index, 1);
        break;
      case 2:
        let tab = state.tabList[0];
        state.tabList = [tab];
        state.activeTab = tab.router;
        break;
      case 3:
        for (let i = (state.tabList.length - 1); i > 0; i--) {
          setTimeout(() => {  // 此处的定时器必须要有,用于解决frame删除不完的问题
            if (state.tabList[i].router != state.activeTab) {
              state.tabList.splice(i, 1);
            }
          }, 0);
        }
        break;
    }
  }
};

const actions = {};

const getters = {};


export default {
  name: "MenuState",
  data: {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  }
}



// WEBPACK FOOTER //
// ./src/store/platform/menuState.js